export default "__VITE_ASSET__2cf59211__"